import { EntityAuditDetailed } from "@modernary/mui/components/audit";
import { NotAuthorized, NotFound, PasswordChanged } from "@modernary/mui/components/common";
import { analyticsRouteNames, default as analyticsRoutes } from "./views/analytics/analyticsRoutes";
import { applicationRouteNames, default as applicationRoutes } from "./views/application/applicationRoutes";
import { complaintRouteNames, default as complaintRoutes } from "./views/complaint/complaintRoutes";
import { disposalReportRouteNames, default as disposalReportRoutes } from "./views/disposalReport/disposalReportRoutes";
import { facilitySiteRouteNames, default as facilitySiteRoutes } from "./views/facilitySite/facilitySiteRoutes";
import Home from "./views/Home.vue";
import { inspectionRouteNames, default as inspectionRoutes } from "./views/inspection/inspectionRoutes";
// import loginRoutes from "./views/login/loginRoutes";
import { LE } from "./constants/enumsNew";
import { accessRequestRouteNames, default as accessRequestRoutes } from "./views/accessRequest/accessRequestRoutes";
import { organizationRouteNames, default as organizationRoutes } from "./views/organization/organizationRoutes";
import { permitRouteNames, default as permitRoutes } from "./views/permit/permitRoutes";
import { permitVersionRouteNames, default as permitVersionRoutes } from "./views/permitVersion/permitVersionRoutes";
import { personRouteNames, default as personRoutes } from "./views/person/personRoutes";
import {
  recyclingReportRouteNames,
  default as recyclingReportRoutes,
} from "./views/recyclingReport/recyclingReportRoutes";
import { reportRouteNames, default as reportRoutes } from "./views/report/reportRoutes";
import { swmpRouteNames, default as swmpRoutes } from "./views/swmp/swmpRoutes";
// Troubleshoot your routes using this - https://paths.esm.dev

export const routeNames = {
  home: "Home",
  notAuthorized: "NotAuthorized",
  passwordChanged: "PasswordChanged",
  accessRequest: {
    ...accessRequestRouteNames,
  },
  analytics: {
    ...analyticsRouteNames,
  },
  application: {
    ...applicationRouteNames,
  },
  complaint: {
    ...complaintRouteNames,
  },
  disposalReport: {
    ...disposalReportRouteNames,
  },
  facilitySite: {
    ...facilitySiteRouteNames,
  },
  inspection: {
    ...inspectionRouteNames,
  },
  organization: {
    ...organizationRouteNames,
  },
  permit: {
    ...permitRouteNames,
  },
  permitVersion: {
    ...permitVersionRouteNames,
  },
  person: {
    ...personRouteNames,
  },
  recyclingReport: {
    ...recyclingReportRouteNames,
  },
  report: {
    ...reportRouteNames,
  },
  swmp: {
    ...swmpRouteNames,
  },
};

/** @type {import('vue-router').RouterOptions['routes']} */
export const routes = [
  { path: "/", component: Home, name: routeNames.home, meta: { title: "Home" } },
  {
    path: "/unauthorized",
    component: NotAuthorized,
    name: routeNames.notAuthorized,
    meta: { title: "Not Authorized" },
  },
  {
    path: "/password-changed",
    component: PasswordChanged,
    name: routeNames.passwordChanged,
    meta: { title: "Password Changed" },
  },
  {
    path: "/detailedAudit",
    name: "EntityAuditDetailed",
    meta: { title: "Detailed Audit History", isForm: true },
    component: {
      render: () => <EntityAuditDetailed groupCode="EntityType" customMurn={LE.EntityType.Custom} />,
    },
  },
  ...accessRequestRoutes,
  ...analyticsRoutes,
  ...applicationRoutes,
  ...complaintRoutes,
  ...personRoutes,
  ...disposalReportRoutes,
  ...facilitySiteRoutes,
  ...inspectionRoutes,
  // ...loginRoutes,
  ...organizationRoutes,
  ...permitRoutes,
  ...permitVersionRoutes,
  ...recyclingReportRoutes,
  ...reportRoutes,
  ...swmpRoutes,
  { path: "/:path(.*)", component: NotFound },
];
